// PDF Generator - Downloads PDF from server API

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const downloadFromUrl = async (url, filename) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(downloadUrl);
};

const qs = (opts) => (opts && opts.vuoto ? '?vuoto=true' : '');
const suf = (opts) => (opts && opts.vuoto ? '_VUOTO' : '');

export const downloadDDRPdf = async (ddr, opts = {}) => {
  const url = `${API_URL}/api/ddr/${ddr.id}/pdf${qs(opts)}`;
  const filename = `DDR${suf(opts)}_${ddr.serie}_${ddr.numero_ddr}.pdf`;
  await downloadFromUrl(url, filename);
  return { success: true };
};

export const downloadDDTPdf = async (ddr, opts = {}) => {
  const url = `${API_URL}/api/ddr/${ddr.id}/ddt${qs(opts)}`;
  const filename = `DDT${suf(opts)}_${ddr.serie}_${ddr.numero_ddr}.pdf`;
  await downloadFromUrl(url, filename);
  return { success: true };
};

export const downloadBothPdf = async (ddr, opts = {}) => {
  const url = `${API_URL}/api/ddr/${ddr.id}/both${qs(opts)}`;
  const filename = `DDR_DDT${suf(opts)}_${ddr.serie}_${ddr.numero_ddr}.pdf`;
  await downloadFromUrl(url, filename);
  return { success: true };
};

export const shareDDRPdf = async (ddr) => {
  const url = `${API_URL}/api/ddr/${ddr.id}/pdf`;
  if (navigator.share) {
    try {
      await navigator.share({
        title: `DDR ${ddr.serie}-${ddr.numero_ddr}`,
        text: 'Documento di Registrazione',
        url: url
      });
      return { success: true, shared: true };
    } catch (e) {
      console.log('Share failed, opening link');
    }
  }
  window.open(url, '_blank');
  return { success: true };
};

export const shareDDTPdf = async (ddr) => {
  const url = `${API_URL}/api/ddr/${ddr.id}/ddt`;
  if (navigator.share) {
    try {
      await navigator.share({
        title: `DDT ${ddr.serie}-${ddr.numero_ddr}`,
        text: 'Documento di Trasporto',
        url: url
      });
      return { success: true, shared: true };
    } catch (e) {
      console.log('Share failed, opening link');
    }
  }
  window.open(url, '_blank');
  return { success: true };
};
